<template>
    <div class="o-steps-panel-otg">
        <header class="steps-panel-otg-header">
            <h4>
                {{ $t('ui.distance') }}
            </h4>
            <span>
                {{ activePath.distance }} m
            </span>
        </header>
        <section class="steps-panel-section">
            <ul class="steps-panel-list">
                <OPathStepOtg
                    v-for="(step, index) in activePathSteps"
                    :key="index"
                    :step="step"
                    :index="index"
                    :isActive="index === activeStepIndex"
                    tag="li"
                    @onClick="onPathStepClick"
                />
            </ul>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";

import OPathStepOtg from '../../organisms/o-path-step-otg';

import {
    UI_STEP_SELECTED,
    MAP_SHOW_PATH_STEPS
} from "@/shared/components/map-viewer/constants/map-events";

export default {
    name: 'OStepsPanelOtg',
    components: {
        OPathStepOtg
    },
    computed:{
        ...mapState({
            activePath: state => state.activePath,
            activeStepIndex: state => state.activeStepIndex
        }),
        activePathSteps(){
            return this.activePath ? this.activePath.steps : [];
        },
        destinationObject() {
            return this.getDenormalisedObjectById(Number(this.$route.query.mTo));
        },
    },
    methods:{
        onPathStepClick(stepIndex) {
            this.$store.commit('setActiveStepIndex', stepIndex);
            // this.$bus.$emit(UI_STEP_SELECTED, stepIndex);
            this.$bus.$emit(MAP_SHOW_PATH_STEPS, stepIndex);

            //this.$router.push({query: { ...this.$route.query, mv: 'GuideStepView'}});
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />